import React from "react";

import { tw } from "~/utils";

interface UserDetailRowProps {
  field: string;
  value?: string | React.ReactNode;
  className?: string;
}

export const UserDetailRow = ({
  field,
  value,
  className,
}: UserDetailRowProps) => {
  return (
    <div className={tw("flex flex-col gap-1", className)}>
      <div className="align-middle text-sm text-neutral-600">{field}</div>
      <div className="text-lg text-neutral-800">{value}</div>
    </div>
  );
};
